//ol IE polyfills
import "core-js/es6/map";
import "core-js/es6/set";
import 'core-js/es6/number';
import "raf/polyfill";

import React from "react";
import ReactDOM from "react-dom";
import Setup from "./boot/setup";
import registerCache from "./boot/registerServiceWorker";

  

ReactDOM.render(<Setup />, document.getElementById("root"));
// registerCache();



// WEBPACK FOOTER //
// ./src/index.js